module.exports = __webpack_public_path__ + "img/logo-farmacias-descuento.2a4e0350.png";